import BuildingType from '@/roc/building/BuildingType';
import BuildingMaxLevel from '@/roc/building/BuildingMaxLevel';
import Effects from '@/roc/effects/Effects';
import CultureBonus from '@/roc/effects/CultureBonus/CultureBonus';
import CultureAmount from '@/roc/effects/CultureBonus/CultureAmount';
import CultureRange from '@/roc/effects/CultureBonus/CultureRange';

const LargeCultureSite = {
  id: '21',
  name: 'Large Culture Site',
  width: 4,
  height: 3,
  type: BuildingType.CULTURE,
  era: 'classicGreece',
  icon: 'Culture_Range',
  minLevel: 4,
  maxLevel: BuildingMaxLevel.ONE_OFF,
  url: 'https://riseofcultures.wiki.gg/wiki/Home_Cultures/Culture_Sites/Large_Culture_Site',
  flags: 0,
  counts: {
    stoneAge: null,
    bronzeAge: null,
    minoanEra: null,
    classicGreece: 1,
    earlyRome: 1,
    romanEmpire: 1,
    byzantineEra: 1,
    ageOfTheFranks: 1,
    feudalAge: 1,
    iberianEra: 1,
    kingdomOfSicily: 1,
    highMiddleAges: 1,
    earlyGothicEra: 1,
    lateGothicEra: 1,
  },
  effects: Effects.create([
    new CultureBonus(
      CultureAmount.asPerLevel([0, 0, 0, 750, 860, 1070, 1290, 1500, 1820, 2140, 2570, 3110, 3500, 3890]),
      CultureRange.asFlat(3),
    ),
  ]),
};

export default LargeCultureSite;
